<script>
/**
 * ****************************************************************************
 * @description     :   Component for popup search workrequestcontents
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import { mapActions } from 'vuex';
import template from './template.html';
import repository from '@/utils/repository';

/**
 * Define component chat for popup search work request contents
 */

var ra001900v = {
    template: template,
    props: {
        onSelected: Function,
        initData: Object // initData.bukken_no, initData.ichiji_no
    },
    /*created() {
        this.doSearch();
    },*/
    data() {
        return {
            search: '',
            resultSearch: []
        };
    },
    computed: {
        initObject() {
            return this.initData;
        }
    },
    mounted() {
        this.doSearch();
    },
    watch: {
        initData() {
            this.doSearch();
        }
    },
    methods: {
        ...mapActions('app', ['showHeaderError', 'hideHeaderError']),
        doSearch: function () {
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
            repository
                .get(`inquiry/ra001900v`, {
                    params: {
                        bukkenno: this.initObject.bukken_no,
                        ichiji_cd: this.initObject.ichiji_no,
                        search: this.search
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const length = data.Data.length;
                        const workrequest_cds = this.initObject.workrequest_cd
                            ? this.initObject.workrequest_cd.split(';')
                            : [];
                        for (let i = 0; i < length; i++) {
                            if (
                                workrequest_cds.indexOf(
                                    data.Data[i].workrequest_cd
                                ) >= 0
                            ) {
                                data.Data[i].select_flg = 1;
                            } else {
                                data.Data[i].select_flg = 0;
                            }
                        }
                        this.resultSearch = data.Data;
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        checked(i) {
            return this.resultSearch[i].select_flg == 1;
        },
        onChange(i) {
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
            this.resultSearch[i].select_flg =
                this.resultSearch[i].select_flg == 1 ? 0 : 1;
        },
        getChecked() {
            const result = [];
            const length = this.resultSearch.length;
            for (let i = 0; i < length; i++) {
                if (this.resultSearch[i].select_flg == 1) {
                    result.push(this.resultSearch[i]);
                }
            }
            return result;
        },
        selectData() {
            const data = this.getChecked();
            if (data.length == 0) {
                this.showHeaderError(['明細行を１行以上選択してください。']);
                return;
            }
            if (
                this.resultSearch &&
                this.resultSearch.length > 0 &&
                this.onSelected
            ) {
                this.onSelected(data, true);
            }
            this.$refs.close.click();
        }
    }
};
export default ra001900v;
</script>
